import PropTypes from 'prop-types';
import React from 'react';
import { Col } from 'react-bootstrap';

import useCompanySetting from 'App/hooks/useCompanySetting';
import useFetchPatientIdentifiers from 'App/hooks/useFetchPatientIdentifiers';
import { TextField } from 'Shared/form/TextField';
import withFormikFields from 'Shared/form/withFormikFields';
import CommonPatientFieldWrapper from '../CommonPatientFieldWrapper';

const EhrIdField = ({ fieldValues: { id } }) => {
    const { data: ehrPrimaryIdType } = useCompanySetting('ehrPrimaryIdType', { defaultValue: '' });
    const { data: patientIdentifiers } = useFetchPatientIdentifiers(id);
    const ehrId = Object.values(patientIdentifiers || {}).find(
        (i) => i.identifierType === ehrPrimaryIdType
    )?.identifier;

    return (
        <CommonPatientFieldWrapper fieldName="ehrId">
            {(commonProps) => (
                <Col md={3}>
                    {ehrPrimaryIdType && (
                        <TextField
                            fieldName={commonProps.fieldName}
                            label="EHR ID"
                            placeholder="EHR ID"
                            disabled
                            value={ehrId}
                        />
                    )}
                </Col>
            )}
        </CommonPatientFieldWrapper>
    );
};

EhrIdField.propTypes = {
    fieldValues: PropTypes.shape({
        id: PropTypes.string,
    }).isRequired,
};

export default withFormikFields({ WrappedComponent: EhrIdField, fieldNames: ['id'] });
